// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React, {Fragment, useContext} from 'react';
import {Settings_context} from '../settings_ctx';
import cn from 'classnames';
import {use_countries} from './forms/use_countries';
import {Button} from '../../../shared/button';
import styles from './coverage.module.less';


interface i_coverage_props {
    title?: string;
    subtitle?: string;
    description?: string;
    cls?: string;
}

const flags = ['US', 'GB', 'CH', 'IS', 'RO', 'ES', 'JP', 'DE', 'AU', 'SE'];

export const Coverage = ({title='Worldwide Coverage', cls='',
    subtitle='You can be anywhere with Hola', description}
    : i_coverage_props)=>{
    const {theme} = useContext(Settings_context);
    const {countries_by_code} = use_countries('f32',
        cn(styles.flag_wrap, theme.xs, theme.P), styles.flag_icon);
    if (!description)
    {
      description = 'We have a super-fast network of powerful servers all '
          +'around the globe, so that everything runs smoothly without lags '
          +'or waiting.';
    }
    return <div className={cn(styles.coverage, cls)}>
      <div className={theme.container}>
        <h2 className={styles.coverage_title}>{title}</h2>
        <h3 className={theme.grey_2}>{subtitle}</h3>
        <p className={styles.coverage_desc}>{description}</p>
        <div className={styles.flags}>
          {flags.map(el=>{
            return <Fragment key={el}>
            {countries_by_code[el].rendered_item}
            </Fragment>;
          })}
        </div>
        <Button caption={'See all countries'} cls={styles.coverage_button}
          to={'/vpn'} arrow/>
      </div>
    </div>;
};
